import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "home-page__content" }
const _hoisted_3 = { class: "home-page__message-card" }
const _hoisted_4 = { class: "home-page__message-header" }
const _hoisted_5 = { class: "home-page__message-desc" }
const _hoisted_6 = {
  key: 0,
  class: "home-page__empty"
}
const _hoisted_7 = {
  key: 1,
  class: "home-page__message-list"
}
const _hoisted_8 = { class: "home-page__message-item-main" }
const _hoisted_9 = { class: "home-page__message-time" }
const _hoisted_10 = { class: "home-page__message-content" }

import {
  useBaseOperateStore,
  type HpsfirProFormItem,
  type HpsfirProStatsCardItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { computed, ref } from 'vue';
import dayjs from 'dayjs';
import { Activity, MessageSquare, QrCode, Router } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const baseOperateStore = useBaseOperateStore();

const statistics = ref({
  onlineDevice: 0,
  totalCount: 0,
  totalDevice: 0,
  totalPeople: 0,
});

const messages = ref<any[]>([]);

const canSendMessage = computed(() => baseOperateStore.operates?.some((item) => item.key === 'SEND_MESSAGE'));
const canDeleteMessage = computed(() => baseOperateStore.operates?.some((item) => item.key === 'DEL_MESSAGE'));
const canDeleteUser = computed(() => baseOperateStore.operates?.some((item) => item.key === 'DEL_USER'));
const canClearUserLoginInfo = computed(() => baseOperateStore.operates?.some((item) => item.key === 'CLEAR_USER_LOGIN_INFO'));

const statCards = computed<HpsfirProStatsCardItem[]>(() => [
  {
    label: '累计设备数量',
    value: statistics.value.totalDevice,
    icon: Router,
    color: 'blue',
    subText: '全部已绑定设备',
  },
  {
    label: '在线设备',
    value: statistics.value.onlineDevice,
    icon: Activity,
    color: 'green',
    subText: '当前在线设备',
  },
  {
    label: '累计扫码次数',
    value: statistics.value.totalCount,
    icon: QrCode,
    color: 'purple',
    subText: '历史扫码总次数',
  },
  {
    label: '累计扫码人数',
    value: statistics.value.totalPeople,
    icon: MessageSquare,
    color: 'orange',
    subText: '历史扫码用户数',
  },
]);

const messageItems = ref<HpsfirProFormItem[]>([
  {
    name: 'msg',
    label: '内容',
    rule: [{ required: true }],
    type: 'textaera',
  },
]);

const deleteUserItems = ref<HpsfirProFormItem[]>([
  {
    name: 'phone',
    label: '手机号',
    rule: [
      { required: true, message: '请输入手机号' },
      { pattern: /^1\d{10}$/u, message: '请输入正确的手机号' },
    ],
    type: 'string',
  },
]);

const clearLoginInfoItems = ref<HpsfirProFormItem[]>([
  {
    name: 'count',
    label: '清理数量',
    rule: [
      { required: true, message: '请输入清理数量' },
      { type: 'number', min: 1, message: '清理数量必须大于0' },
    ],
    type: 'number',
  },
]);

const sendMsgForm = ref<any>();
const deleteUserForm = ref<any>();
const clearLoginInfoForm = ref<any>();
const deleteMessageDialogRef = ref<any>();
const deleteUserDialogRef = ref<any>();

const statisticLoading = ref(false);

const getStatistics = async() => {
  try {
    statisticLoading.value = true;
    const res = await useApi().homeApi.getHomeStatisticshome();
    statistics.value = res.data.data || statistics.value;
  } finally {
    statisticLoading.value = false;
  }
};

const messageLoading = ref(false);
const getMessage = async() => {
  try {
    messageLoading.value = true;
    const res = await useApi().homeApi.listMessagehome({ conditions: {} });
    messages.value = res.data.data || [];
  } finally {
    messageLoading.value = false;
  }
};

function refreash() {
  getStatistics();
  getMessage();
}

const handleSendMsg = async(row: any) => {
  messageLoading.value = true;
  await useApi().homeApi.addMessagehome({ messageAdminVo: row });
  ElMessage.success('发送成功');
  refreash();
};

const formatDeleteMessageInfo = (row: any) => `您正在进行删除站内信(${row?.id})操作，请谨慎操作`;

const deleteAction = async(row: any) => {
  await useApi().homeApi.delMessagehome(row.id);
  ElMessage.success('删除成功');
  refreash();
};

const handleDeleteMsg = (msgId: number) => {
  deleteMessageDialogRef.value?.showDialog({ id: msgId });
};

const formatDeleteUserInfo = (row: any) => `您正在删除手机号(${row?.phone})的基础用户、关联店铺、开门数据等业务数据，此操作不可恢复，请谨慎操作`;

const deleteUserAction = async(row: any) => {
  const phone = String(row?.phone || '').trim();
  const res = await useApi().homeApi.delUserByPhonehome({ phone });
  const storeCount = res.data.data?.storeCount || 0;
  ElMessage.success(storeCount ? `删除成功，已清理${storeCount}个关联店铺` : '删除成功');
  refreash();
};

const handleDeleteUserFormOk = (row: any) => {
  const phone = String(row?.phone || '').trim();
  if (!/^1\d{10}$/u.test(phone)) {
    ElMessage.error('请输入正确的手机号');
    return;
  }
  deleteUserDialogRef.value?.showDialog({ phone });
};

const handleClearLoginOk = async(row: any) => {
  const count = Number(row?.count);
  if (!Number.isSafeInteger(count) || count <= 0) {
    ElMessage.error('请输入大于0的清理数量');
    return;
  }
  const res = await useApi().homeApi.clearUserLoginInfohome({ count });
  const deletedCount = res.data.data?.deletedCount || 0;
  const remainingUnexpiredCount = res.data.data?.remainingUnexpiredCount || 0;
  ElMessage.success(`清理完成，已清理${deletedCount}条登录信息，剩余未过期${remainingUnexpiredCount}条`);
};

function handleClickSend() {
  sendMsgForm.value?.reset();
  sendMsgForm.value?.showDialog();
}

function handleClickDeleteUser() {
  deleteUserForm.value?.reset();
  deleteUserForm.value?.showDialog();
}

function handleClickClearLoginInfo() {
  clearLoginInfoForm.value?.reset();
  clearLoginInfoForm.value?.showDialog();
}

const headerActions = computed(() => [
  {
    key: 'refresh',
    name: '刷新数据',
    handler: () => refreash(),
    variant: 'outline' as const,
  },
  ...(canSendMessage.value
    ? [
      {
        key: 'send',
        name: '发送站内信',
        handler: () => handleClickSend(),
      },
    ]
    : []),
  ...(canDeleteUser.value
    ? [
      {
        key: 'delete-user',
        name: '删除用户',
        handler: () => handleClickDeleteUser(),
        variant: 'destructive' as const,
      },
    ]
    : []),
  ...(canClearUserLoginInfo.value
    ? [
      {
        key: 'clear-user-login-info',
        name: '清理用户登录信息',
        handler: () => handleClickClearLoginInfo(),
        variant: 'destructive' as const,
      },
    ]
    : []),
]);

refreash();

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProPageHeader = _resolveComponent("HpsfirProPageHeader")!
  const _component_HpsfirProStatsCards = _resolveComponent("HpsfirProStatsCards")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirProDangerDialog = _resolveComponent("HpsfirProDangerDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProPageHeader, {
      title: "首页",
      "title-en": "DASHBOARD",
      description: "查看设备、扫码和站内信概览",
      "top-operates": headerActions.value,
      "max-visible-actions": 4
    }, null, 8, ["top-operates"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_HpsfirProStatsCards, {
        class: "home-page__stats",
        items: statCards.value
      }, null, 8, ["items"]), [
        [_directive_loading, statisticLoading.value]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "home-page__message-title" }, "站内信", -1)),
            _createElementVNode("div", _hoisted_5, "最近 " + _toDisplayString(messages.value.length) + " 条站内通知", 1)
          ])
        ]),
        (!messages.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "home-page__empty-icon" }, "MSG", -1),
              _createElementVNode("div", { class: "home-page__empty-title" }, "暂无站内信", -1),
              _createElementVNode("div", { class: "home-page__empty-desc" }, "新的通知会显示在这里。", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg) => {
                return (_openBlock(), _createElementBlock("article", {
                  class: "home-page__message-item",
                  key: msg.id
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("time", _hoisted_9, _toDisplayString(_unref(dayjs)(msg.createTime).format('YYYY/MM/DD')), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(msg.msg), 1)
                  ]),
                  (canDeleteMessage.value)
                    ? (_openBlock(), _createBlock(_component_HpsfirButton, {
                        key: 0,
                        variant: "destructive",
                        size: "sm",
                        onClick: () => handleDeleteMsg(msg.id)
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("删除", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ])), [
        [_directive_loading, messageLoading.value]
      ])
    ]),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "sendMsgForm",
      ref: sendMsgForm,
      title: "发送站内信",
      items: messageItems.value,
      onOk: handleSendMsg
    }, null, 8, ["items"]),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "deleteUserForm",
      ref: deleteUserForm,
      title: "删除用户",
      items: deleteUserItems.value,
      onOk: handleDeleteUserFormOk
    }, null, 8, ["items"]),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "clearLoginInfoForm",
      ref: clearLoginInfoForm,
      title: "清理用户登录信息",
      items: clearLoginInfoItems.value,
      onOk: handleClearLoginOk
    }, null, 8, ["items"]),
    _createVNode(_component_HpsfirProDangerDialog, {
      ref_key: "deleteMessageDialogRef",
      ref: deleteMessageDialogRef,
      title: "删除站内信",
      "opt-name": "删除",
      "on-ok": deleteAction,
      "format-dangder-delete-info": formatDeleteMessageInfo
    }, null, 512),
    _createVNode(_component_HpsfirProDangerDialog, {
      ref_key: "deleteUserDialogRef",
      ref: deleteUserDialogRef,
      title: "删除用户",
      "opt-name": "删除用户",
      "on-ok": deleteUserAction,
      "format-dangder-delete-info": formatDeleteUserInfo
    }, null, 512)
  ]))
}
}

})